import { createFeatureSelector, createSelector } from '@ngrx/store';

import { State } from '../model';
import { userUiFeatureKey } from '../user-ui.reducer';

/**
 * Feature selector
 */
export const selectUserUiState = createFeatureSelector<State>(userUiFeatureKey);

export const selectStringifiedUserUiState = createSelector(
  selectUserUiState,
  (state: State) => JSON.stringify(state),
);

/**
 * Returns the aside menu opened
 */
export const selectAsideMenuOpened = createSelector(
  selectUserUiState,
  (state: State) => state.asideMenuOpened,
);

/**
 * Returns the user menu opened
 */
export const selectUserMenuOpened = createSelector(
  selectUserUiState,
  (state: State) => state.userMenuOpened,
);

export const selectPromotedLandingPageFeed = createSelector(
  selectUserUiState,
  (state: State) => state.promotedLandingPageFeed,
);

export const selectIsPowerListPromoted = createSelector(
  selectPromotedLandingPageFeed,
  Boolean,
);

export const selectMainHeaderHeight = createSelector(
  selectUserUiState,
  (state: State) => state?.mainHeaderHeight,
);

/**
 * Returns news-feed view
 */
export const selectNewsFeedView = createSelector(
  selectUserUiState,
  (state: State) => state.singleColumnView,
);

export const selectCurrentPresetValue = createSelector(
  selectUserUiState,
  (state) => state.presetFilter,
);

export const selectOverlaysOpened = createSelector(
  selectUserUiState,
  (state) => state.overlaysOpened,
);

export const selectPBasketView = createSelector(
  selectUserUiState,
  (state) => state.pBasketView,
);

export const selectExpandedProductDetails = createSelector(
  selectUserUiState,
  (state) => state.expandedProductDetails,
);

export const selectPanes = createSelector(selectUserUiState, (state) => {
  return state.panes;
});
